import { render, staticRenderFns } from "./metrics.vue?vue&type=template&id=4aa8a5e6&"
import script from "./metrics.vue?vue&type=script&lang=js&"
export * from "./metrics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports